import React from 'react'
import Plot from 'react-plotly.js'

export default function Chart({ title, data }) {
    const months = data?.range || [
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
    ]
    const totalCost = data?.series[0]?.data || [0, 0, 0, 0, 0, 0]
    const totalVariance = data?.series[1]?.data || [0, 0, 0, 0, 0, 0]

    // Calculate totals
    const totalCostSum = data?.total_cost || 0
    const totalVarianceSum = data?.total_variance || 0

    return (
        <div className="rounded-lg bg-white px-6 pt-6 pb-6 shadow-sm">
            <div className="flex justify-between items-center mb-6">
                <h4 className="text-black font-bold text-lg mb-4">
                    {title || 'Transport Service Providers Report'}
                </h4>
            </div>

            <div className="flex gap-8 mb-6">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-blue-600"></span>
                        <span className="text-2xl font-bold text-black">
                            A$
                            {totalCostSum.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </span>
                    </div>
                    <div className="text-sm text-gray-600 ml-5">Total Cost</div>
                </div>
                <div>
                    <div className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-green-500"></span>
                        <span className="text-2xl font-bold text-black">
                            A$
                            {totalVarianceSum.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </span>
                    </div>
                    <div className="text-sm text-gray-600 ml-5">
                        Total Variance
                    </div>
                </div>
            </div>

            <div id="chart">
                <Plot
                    data={[
                        {
                            type: 'scatter',
                            x: months,
                            y: totalCost,
                            name: 'Total Cost',
                            line: {
                                color: '#6366F1',
                                width: 2,
                                shape: 'spline',
                            },
                            mode: 'lines',
                        },
                        {
                            type: 'scatter',
                            x: months,
                            y: totalVariance,
                            name: 'Total Variance',
                            line: {
                                color: '#10B981',
                                width: 2,
                                shape: 'spline',
                            },
                            mode: 'lines',
                        },
                    ]}
                    layout={{
                        barmode: 'group',
                        showlegend: false,
                        xaxis: {
                            showgrid: false,
                            showline: false,
                        },
                        yaxis: {
                            tickformat: '~s',
                            tickprefix: 'A$',
                            gridcolor: '#E5E7EB',
                            showline: false,
                            rangemode: 'tozero',
                        },
                        plot_bgcolor: 'white',
                        paper_bgcolor: 'white',
                        margin: {
                            l: 80,
                            r: 20,
                            t: 20,
                            b: 60,
                        },
                        bargap: 0.5,
                        bargroupgap: 0.1,
                    }}
                    config={{
                        displayModeBar: false,
                        responsive: true,
                    }}
                    useResizeHandler={true}
                    style={{ width: '100%', height: '400px' }}
                />
            </div>
        </div>
    )
}
